import React, { PureComponent } from 'react';
import has from 'lodash/has';
import map from 'lodash/map';

import { Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import { getDataMapColumns } from 'js/lib/DataMapsProcessor';
class DynamicDataMapConfiguration extends PureComponent {
  render() {
    const { dataMap } = this.props;

    const mapPrimaryKey = dataMap && has(dataMap, 'map_primary_key') ? dataMap.map_primary_key : '';
    const mapColumns = dataMap ? getDataMapColumns(dataMap) : {};
    const dataDefaults = dataMap && has(dataMap, 'data_defaults') ? dataMap.data_defaults : {};
    return (
      <div>
        <div className="details-accordion-group">
          <Accordion className="accordion-item" key={1} defaultExpanded>
            <AccordionSummary
              className="accordion-title"
              expandIcon={<ExpandMore fontSize="large" />}
            >
              <div className="accordion-title-content">
                <h2>Lookup Columns</h2>
                <div className="toggle-text">Click to expand/collapse</div>
              </div>
            </AccordionSummary>
            <AccordionDetails className="accordion-body">
              <div className="accordion-body-content">
                <div className={'full-width-table'}>
                  <div className={'table-header'}>
                    <Grid container className={'table-header-row'}>
                      <Grid item xs={1}>
                        Primary
                      </Grid>
                      <Grid item xs>
                        Column Name
                      </Grid>
                      <Grid item xs={4}>
                        Default Value
                      </Grid>
                    </Grid>
                  </div>
                  <div className={'table-body'}>
                    {map(mapColumns, (col, k) => {
                      const isPrimary = k === mapPrimaryKey;
                      const defaultValue = has(dataDefaults, k) ? `${dataDefaults[k]}` : '';
                      return (
                        <Grid container key={k} className={'table-body-row'}>
                          <Grid item xs={1} alignContent="center">
                            {isPrimary ? <span>&#10003;</span> : null}
                          </Grid>
                          <Grid item xs>
                            {k}
                          </Grid>
                          <Grid item xs={4}>
                            {defaultValue}
                          </Grid>
                        </Grid>
                      );
                    })}
                  </div>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    );
  }
}

export default DynamicDataMapConfiguration;
